import { render, staticRenderFns } from "./ModelManagerList.vue?vue&type=template&id=3d83e21e&"
import script from "./ModelManagerList.vue?vue&type=script&lang=js&"
export * from "./ModelManagerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports